<template>
  <!-- <div class="boxall"> -->
  <!-- <div class="tit04">地图总览</div> -->
  <div class="mapbox">
    <!-- TODO: 地图总览 -->
    <div class="bg-image">
      <div class="map-charts" ref="chartsDOM"></div>
    </div>
  </div>

  <!-- </div> -->
</template>

<script>
// import * as echarts from 'echarts'
// import townsData from '../json/res_getHuangmeimMap.json'
// import huangmeiData from '../json/huangmeimMap.json'
// import polylineToGeoJSON from '@/utils/polylineToGeoJSON'

export default {
  name: 'CenterMap'

  // mounted() {
  //   var myChart = echarts.init(this.$refs['chartsDOM'])

  //   // 使用正确的 polyline 数据
  //   const huangmeiGeoJSON = polylineToGeoJSON('黄梅县', huangmeiData.polyline)

  //   // 注册县级地图
  //   echarts.registerMap('HM', huangmeiGeoJSON)

  //   // 准备散点数据
  //   const towns = townsData.districts.map(t => {
  //     const [lng, lat] = t.center.split(',').map(Number)
  //     return { name: t.name, value: [lng, lat] }
  //   })

  //   const option = {
  //     geo: {
  //       map: 'HM',
  //       roam: true,
  //       label: { show: false },
  //       itemStyle: {
  //         areaColor: '#0d8d8c91',
  //         borderColor: '#00ffff'
  //       }
  //     },
  //     series: [
  //       {
  //         name: '镇中心点',
  //         type: 'scatter',
  //         coordinateSystem: 'geo',
  //         data: towns,
  //         symbolSize: 5,
  //         label: {
  //           show: true,
  //           formatter: '{b}',
  //           position: 'right',
  //           color: '#fff',
  //           fontSize: 5,
  //           overflow: 'truncate' // 超出自动截断
  //         },
  //         itemStyle: { color: '#ff5722' },
  //         tooltip: { formatter: '{b}' },
  //         labelLayout: {
  //           hideOverlap: true // 自动隐藏重叠
  //         }
  //       }
  //     ]
  //   }

  //   myChart.setOption(option)
  // }
}
</script>

<style scoped>
.container {
  width: 100%;
  /* 核心：确保每个组件都继承父级分配的高度 */
  /* height: calc(100% - 12px); */
  /* background: url('../images/bg_block.png') no-repeat; */
  height: 100%;

  position: relative;
  margin-bottom: 12px;
  z-index: 10;
  display: flex;
  flex-direction: column; /* 内部内容也纵向排列 */
}

.mapbox {
  height: 100%;
  padding: 16px;
}

.bg-image {
  width: 100%;
  height: 100%;

  background: url('../assets/images/bg_middle_pic.jpg') no-repeat center center;

  background-size: cover;
  border-radius: 12px;
}

.map-charts {
  height: 100%;
  width: 100%;
}
</style>
